/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import { number, string, array } from "prop-types";
import { IntlProvider, FormattedDate } from "react-intl";
import ProgressBar from "../ProgressBar";
import messages from "../messages";

const AssignmentRow = ({ id, openDate, dueDate, title, grading, locale }) => {
  return (
    <IntlProvider locale={locale} messages={messages}>
      <tr role="row" tabIndex="0" key={id}>
        <td>
          <FormattedDate
            value={new Date(openDate)}
            year="numeric"
            month="long"
            day="2-digit"
          />
        </td>
        <td>
          <FormattedDate
            value={new Date(dueDate)}
            year="numeric"
            month="long"
            day="2-digit"
          />
        </td>
        <td>{title}</td>
        <td>
          <ProgressBar id={"progressBar" + id} partitionItems={grading} />
        </td>
      </tr>
    </IntlProvider>
  );
};

AssignmentRow.propTypes = {
  id: number.isRequired,
  openDate: number.isRequired,
  dueDate: number.isRequired,
  title: string.isRequired,
  grading: array.isRequired,
  locale: string,
};

AssignmentRow.defaultProps = {
  locale: "en",
};

export default AssignmentRow;
